import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { CheckOutlined } from "@ant-design/icons";
import {
  Button,
  AutoComplete,
  Modal,
  notification,
  Table,
  Tooltip,
} from "antd";
import _ from "lodash";
import { errorAction, successAction, types as at } from "@authzsvc/api-lib";

const ApplicationSearchModal = ({
  title,
  buttonText,
  searchForApplication,
  onSelect,
  icon,
  disabled = false,
}) => {
  const [visible, setVisible] = useState(false);
  const [searchIsLoading, setSearchIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const modalColumns = [
    {
      title: "Name",
      dataIndex: "displayName",
    },
    {
      title: "Action",
      dataIndex: "id",
      render: function ActionButton(_, record) {
        return (
          <Button
            onClick={() => handleSelect(record)}
            icon={<CheckOutlined />}
          />
        );
      },
    },
  ];

  const handleSelect = (record) => {
    onSelect(record);
    setVisible(false);
  };

  const openUpdateModal = (e) => {
    e.preventDefault();
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const debouncedSearch = _.debounce((value) => {
    if (value.length >= 2) {
      setSearchIsLoading(true);
      let searchCriteria = {
        filter: `applicationIdentifier:Contains:${value}`,
        sort: "applicationIdentifier:asc",
      };

      searchForApplication(searchCriteria).then((action) => {
        if (
          action.type === successAction(at.SEARCH_MY_APPLICATIONS) ||
          action.type === successAction(at.SEARCH_ALL_APPLICATIONS)
        ) {
          setDataSource(action.payload.data);
          setSearchIsLoading(false);
        } else if (
          action.type === errorAction(at.SEARCH_MY_APPLICATIONS) ||
          action.type === errorAction(at.SEARCH_ALL_APPLICATIONS)
        ) {
          notification["error"]({
            message: action.payload.title,
            description: action.payload.data.message,
          });
          setSearchIsLoading(false);
        }
      });
    }
  }, 500);

  return (
    <>
      <Tooltip title={title}>
        <Button
          id="searchWithModal"
          onClick={openUpdateModal}
          icon={icon}
          disabled={disabled}
        >
          {buttonText}
        </Button>
      </Tooltip>
      <Modal
        style={{ minWidth: "90%" }}
        centered
        title={title}
        open={visible}
        onOk={handleCancel}
        okText="Close"
        onCancel={handleCancel}
        confirmLoading={searchIsLoading}
      >
        <p>Type at least 2 characters of the application name.</p>
        <AutoComplete
          style={{ minWidth: "50%" }}
          onChange={debouncedSearch}
          onSearch={debouncedSearch}
          placeholder="Application name"
        />
        <Table
          style={{ marginTop: "10px" }}
          loading={searchIsLoading}
          rowKey="id"
          pagination={{
            pageSize: 10,
          }}
          columns={modalColumns}
          dataSource={dataSource}
        />
      </Modal>
    </>
  );
};

ApplicationSearchModal.propTypes = {
  onSelect: PropTypes.func.isRequired,
  searchForApplication: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  icon: PropTypes.object,
  disabled: PropTypes.bool,
};

export default connect(() => ({}), {})(ApplicationSearchModal);
